import { MediaMap } from "@noya-app/noya-schemas";
import { Observable } from "@noya-app/observable";

export type PublishCallback = () => Promise<MediaMap>;

export class PublishingManager {
  enablePublishing$ = new Observable<boolean>(false);

  setPublishingEnabled(enabled: boolean) {
    this.enablePublishing$.set(enabled);
  }

  getFilesToPublish?: PublishCallback;
}
